export default {
  0: { label: 'New', color: 'warning' },
  1: { label: 'Contacted', color: 'grey' },
  2: { label: 'Qualified', color: 'primary' },
  3: { label: 'Not Interested', color: 'red' },
  4: { label: 'Converted to proposal', color: 'success' }
};